import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { ContentBlock, FormBlock, PortalSupport } from 'components'
import { RegisterForm } from '../forms'
import * as Types from 'types'
import { useCommunity, displaySubmitFailure } from 'utils'
import { SIGN_IN_PATH, ARTIST_PORTAL_PATH } from 'config'
import PropTypes from 'prop-types'
import * as apiActions from 'api-actions'
import * as actions from '../actions'
import { selectors as globalSelectors } from 'global-reducer'

const propTypes = {
  signUp: PropTypes.func.isRequired,
  signUpSuccess: PropTypes.func.isRequired,
  disciplines: PropTypes.arrayOf(Types.discipline),
  demographics: PropTypes.arrayOf(Types.demographic),
}

const defaultProps = {}

function Register({ signUp, signUpSuccess, disciplines, demographics }) {
  const community = useCommunity()

  return (
    <ContentBlock>
      <FormBlock>
        <RegisterForm
          onSubmit={
            // Pass params to onSubmitSuccess handler
            (params) =>
              signUp(params).then((response) => ({ ...params, ...response }))
          }
          onSubmitSuccess={(response) =>
            signUpSuccess({
              ...response,
              redirectUrl: `/${SIGN_IN_PATH}/account-pending-confirmation`,
            })
          }
          onSubmitFail={displaySubmitFailure}
          initialValues={{ portal: ARTIST_PORTAL_PATH }}
          disciplines={disciplines}
          demographics={demographics}
        />
      </FormBlock>
      <PortalSupport
        supportEmail={community.artistSupportEmail}
        portalType={Types.PORTAL.ARTIST_PORTAL}
      />
    </ContentBlock>
  )
}

Register.propTypes = propTypes
Register.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    disciplines: globalSelectors.disciplines(state),
    demographics: globalSelectors.demographics(state),
  }
}

const mapDispatchToProps = {
  signUp: apiActions.signUp,
  signUpSuccess: actions.signUpSuccess,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Register)
